// The screens this app has, generated from .appfactory/product-plan.json.
//
// Imported by the navigation shell rather than replacing it: the shell owns
// router.js — bottom-tabs, stack and sidebar produce different routers, and it
// rewrites that file on every `spec apply`. Two owners for one file is a silent
// fight, so the product contributes ROUTES and the shell decides what to do
// with them.
//
// `primary` marks a screen that earns a place in the navigation itself.

import PlayPage from './pages/PlayPage.vue';
import EndurancePage from './pages/EndurancePage.vue';
import DailyPage from './pages/DailyPage.vue';
import TrophiesPage from './pages/TrophiesPage.vue';
import ChainReactionPage from './pages/ChainReactionPage.vue';
import HigherLowerPage from './pages/HigherLowerPage.vue';
import OddOneOutPage from './pages/OddOneOutPage.vue';
import LastGaspPage from './pages/LastGaspPage.vue';
import GuessTheThingPage from './pages/GuessTheThingPage.vue';
import SortItPage from './pages/SortItPage.vue';
import ResultsPage from './pages/ResultsPage.vue';
import TopicsPage from './pages/TopicsPage.vue';

export const PRODUCT_ROUTES = [
  {
    id: 'play',
    path: '/tabs/play',
    label: 'Play',
    component: PlayPage,
    primary: true,
    destination: true,
  },
  {
    id: 'endurance',
    path: '/tabs/endurance',
    label: 'Endurance',
    component: EndurancePage,
    primary: true,
    destination: true,
  },
  {
    id: 'daily',
    path: '/tabs/daily',
    label: 'Daily',
    component: DailyPage,
    primary: true,
    destination: true,
  },
  {
    id: 'trophies',
    path: '/tabs/trophies',
    // The tab bar, the header and the screen itself all say Trophies; this
    // said Trophy Room, and this is the label QA and any generated navigation
    // read. One screen with two names is one screen too many.
    label: 'Trophies',
    component: TrophiesPage,
    primary: true,
    destination: true,
  },
  {
    id: 'chain-reaction',
    path: '/tabs/play/chain-reaction',
    label: 'Chain Reaction',
    component: ChainReactionPage,
    primary: false,
    destination: false,
  },
  {
    id: 'higher-lower',
    path: '/tabs/play/higher-lower',
    label: 'Higher or Lower',
    component: HigherLowerPage,
    primary: false,
    destination: false,
  },
  {
    id: 'odd-one-out',
    path: '/tabs/play/odd-one-out',
    label: 'Odd One Out',
    component: OddOneOutPage,
    primary: false,
    destination: false,
  },
  {
    id: 'last-gasp',
    path: '/tabs/play/last-gasp',
    label: 'Last Gasp',
    component: LastGaspPage,
    primary: false,
    destination: false,
  },
  {
    id: 'guess-the-thing',
    path: '/tabs/play/guess-the-thing',
    label: 'Guess the Thing',
    component: GuessTheThingPage,
    primary: false,
    destination: false,
  },
  {
    id: 'sort-it',
    path: '/tabs/play/sort-it',
    label: 'Sort It',
    component: SortItPage,
    primary: false,
    destination: false,
  },
  {
    id: 'results',
    path: '/tabs/play/results',
    label: 'Results',
    component: ResultsPage,
    primary: false,
    destination: false,
  },
  // The same Results screen, once per tab that can finish a run in it.
  //
  // Endurance and the Daily are TAB ROOTS. Sending them to /tabs/play/results
  // was a replace from one tab straight into another tab's child, and
  // IonTabs does not survive it: the run ended, Results appeared, and every
  // button in the tab bar went dead. Finishing inside your own tab keeps the
  // outlet's idea of where it is intact.
  {
    id: 'results-endurance',
    path: '/tabs/endurance/results',
    label: 'Results',
    component: ResultsPage,
    primary: false,
    destination: false,
  },
  {
    id: 'results-daily',
    path: '/tabs/daily/results',
    label: 'Results',
    component: ResultsPage,
    primary: false,
    destination: false,
  },
  {
    id: 'topics',
    path: '/tabs/play/topics',
    label: 'Topics',
    component: TopicsPage,
    primary: false,
    destination: false,
  },
];

export const PRIMARY_ROUTES = PRODUCT_ROUTES.filter((r) => r.primary);

// What the navigation offers. NOT the same question as `primary`.
//
// The tab bar was built from PRIMARY_ROUTES, and `primary` means "the screen
// the app opens on" — exactly one screen per plan. So a four-screen app got a
// one-tab tab bar and three screens nothing could reach. `roles` grades
// importance for QA; it was never a claim about navigation.
//
// A destination is a top-level screen someone navigates TO: primary or
// critical, never a detail screen (reached from its list) and never settings
// (which gets its own toolbar button, because a settings tab crowds out a real
// one). Capped at five — past that a bottom bar stops being usable and the
// platform guidelines say so.
//
// EVERY SCREEN IN THIS FILE USED TO CLAIM `destination: true`, INCLUDING THE
// SIX MODES AND RESULTS. A mode is not a destination — it is something you
// start, from Play, and it comes back. The list is capped at five, so what the
// flag actually produced was Play, Endurance, Daily, Trophies and Chain
// Reaction: a tab bar with one game mode wedged into it and the other five
// nowhere, silently, the next time anything generated the navigation from this
// file. router.js writes its four tabs by hand today, which is the only reason
// nobody has seen it.
export const DESTINATION_ROUTES = PRODUCT_ROUTES.filter((r) => r.destination).slice(0, 5);
export const HOME_ROUTE = (PRIMARY_ROUTES[0] ?? PRODUCT_ROUTES[0])?.path ?? '/';
